import AdvancedCustomFields from 'plugins/AdvancedCustomFields';
import AdvancedForms from 'plugins/AdvancedForms';
import CookieConsent from 'plugins/CookieConsent';
import Leaflet from 'plugins/Leaflet';
import Modals from 'plugins/Modals';
import PostForms from 'plugins/PostForms';
import Share from 'plugins/Share';
import WooCommerce from 'plugins/WooCommerce';
import WooCommerceNotices from 'plugins/WooCommerceNotices';
import WooCommerceTracking from 'plugins/WooCommerceTracking';
import WooCommerceWishlist from 'plugins/WooCommerceWishlist';

const $ = window.jQuery;

/**
 * Initialise enabled plugins
 */
const Plugins = {

    enabled: [],    // list of enabled plugins (automatically uses
                    // `mwb/plugins/list` filter)

    // map plugin name to import
    pluginMapping: {
        'AdvancedCustomFields': AdvancedCustomFields,
        'AdvancedForms': AdvancedForms,
        'CookieConsent': CookieConsent,
        'Leaflet': Leaflet,
        'Modals': Modals,
        'PostForms': PostForms,
        'Share': Share,
        'WooCommerce': WooCommerce,
        'WooCommerceNotices': WooCommerceNotices,
        'WooCommerceTracking': WooCommerceTracking,
        'WooCommerceWishlist': WooCommerceWishlist,
    },

    /**
     * Initialise functionality
     */
    init()
    {

        let vm = this;

        // get enabled plugins from localised script var
        vm.enabled = scriptVars.enabledPlugins || [];

        // go through enabled plugins and initialise them
        vm.enabled.forEach((plugin) => {
            if (typeof vm.pluginMapping[plugin] == 'undefined') {
                if (scriptVars.isDebug) {
                    console.warn(
                        `Plugin init - '${plugin}' does not exist`);
                }
                return;
            }
            vm.pluginMapping[plugin].init();
        });

    },

};

export default Plugins;